
import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { format, utcToZonedTime } from 'date-fns-tz';
import { statesTimeZonesList, timeZoneDefault } from '@/utils/PortalConstants';

@Component({})
export default class TDatepickerDateField extends Vue {
  @Prop(String) public value: string;
  @Prop(String) public state: string;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  public timeString = '';
  public zoneString = '';

  get fieldValue() {
    const stopTimeZone = statesTimeZonesList[this.state]?.timezone || timeZoneDefault;
    let date: Date;
    if (this.value) {
      date = utcToZonedTime(new Date(this.value), stopTimeZone);
    } else {
      date = utcToZonedTime(new Date(), stopTimeZone);
    }
    const value = format(date, 'yyyy-MM-dd');
    this.timeString = format(date, 'HH:mm:ss', { timeZone: stopTimeZone });
    this.zoneString = format(date, 'xxxxx', { timeZone: stopTimeZone });
    return value;
  }

  set fieldValue(value) {
    if (value) {
      value = value + 'T' + this.timeString + this.zoneString;
    }
    this.$emit('input', value || '');
  }

  public handleChange(value: string | null) {
    if (!value) {
      value = '';
    }
    this.$emit('change', value);
  }
}
